module.exports = __webpack_public_path__ + "static/media/BrightBee_FullyAutomated@3x.0b1da0c3.png";